import { useQuery } from "react-query";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";
import getUpcData, { UpcResponse } from "../services/getUpcData";
function useGetUpcData(
  token: string,
  pagination: MRT_PaginationState,
  columnFilters: MRT_ColumnFiltersState,
  sorting: MRT_SortingState
) {
  return useQuery<UpcResponse>({
    queryKey: ["get-upc-data", pagination, columnFilters, sorting],
    queryFn: () => getUpcData({ token, pagination, columnFilters, sorting }),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useGetUpcData;
